import { Component, Inject, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface TermsAndPrivacyData {
  hih: any;
}

@Component({
  selector: 'app-terms-privacy-dialog',
  imports: [MatDialogModule, MatButtonModule, MatExpansionModule],
  templateUrl: './terms-privacy-dialog.component.html',
  styleUrl: './terms-privacy-dialog.component.css',
})
export class TermsPrivacyDialogComponent {
  clickedTerms = signal(false);
  clickedPrivacy = signal(false);

  constructor(
    public dialogRef: MatDialogRef<TermsPrivacyDialogComponent>,
    private snackbar: MatSnackBar,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: TermsAndPrivacyData
  ) {
    this.dialogRef.disableClose = true;
  }

  close(confirm: boolean) {
    this.dialogRef.close({ confirm: confirm });
  }
}
